import { Tooltip } from '@mantine/core';
import { toIocCode } from '@scoring/utils';
import type { CSSProperties } from 'react';

type FlagWidth = 20 | 40 | 80 | 160 | 320;
type FlagHeight = 16 | 20 | 24 | 40 | 60 | 80 | 120 | 240;

// Flags are served from the local IOC-named PNGs in ../flags (bundled by Vite).
const getFlagUrl = (iocCode: string): string => new URL(`../flags/${iocCode}.png`, import.meta.url).href;
const NO_FLAG_URL = getFlagUrl('noflag');

export const CountryFlagDisplay = ({
    iocCode,
    height = 20,
    circle = false,
    style,
}: {
    iocCode: string;
    width?: FlagWidth;
    height?: FlagHeight;
    /** Renders the flag cropped to a circle (diameter = height). */
    circle?: boolean;
    style?: CSSProperties;
}) => {
    // Country codes are stored as IOC; normalise defensively in case a legacy ISO3 value slips through.
    const normalised = toIocCode(iocCode);

    return (
        <Tooltip label={iocCode}>
            <img
                src={normalised ? getFlagUrl(normalised) : NO_FLAG_URL}
                alt={`${iocCode} flag`}
                style={{
                    height: `${height}px`,
                    width: `${circle ? height : Math.round(height * 2)}px`,
                    objectFit: circle ? 'cover' : 'contain',
                    border: '0px solid #222',
                    borderRadius: circle ? '50%' : '0px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    ...style,
                }}
                onError={(e) => {
                    // Fall back to the generic flag when a country's flag is missing.
                    if (e.currentTarget.src !== NO_FLAG_URL) e.currentTarget.src = NO_FLAG_URL;
                }}
            />
        </Tooltip>
    );
};
